import type { ReminderProgressView } from "@/lib/reminderProgress";

const TONES = {
  running: { label: "text-indigo-700", dot: "bg-indigo-600", sent: "bg-indigo-600" },
  you: { label: "text-orange-700", dot: "bg-orange-500", sent: "bg-gray-400" },
  stopped: { label: "text-gray-700", dot: "bg-gray-400", sent: "bg-gray-400" },
  error: { label: "text-red-700", dot: "bg-red-600", sent: "bg-indigo-600" },
} as const;

/** Barre de progression des relances devis, en bas de la carte Kanban. */
export function ReminderProgressBar({ view }: { view: ReminderProgressView }) {
  const tone = TONES[view.tone];
  const total = view.segments.length;
  return (
    <div className="mt-2 rounded-md bg-gray-50 px-2.5 py-2" role="group" aria-label={`Relances : ${view.label}, ${view.sent} sur ${total}`}>
      <div className="flex items-baseline justify-between gap-2 text-xs font-semibold">
        <span className={`flex min-w-0 items-center gap-1.5 ${tone.label}`}>
          <span className={`h-2 w-2 flex-none rounded-full ${tone.dot}`} aria-hidden="true" />
          <span className="truncate">{view.label}</span>
        </span>
        <span className="flex-none tabular-nums text-gray-500">
          {view.sent}/{total}
        </span>
      </div>
      <div className="mt-1.5 grid gap-[3px]" style={{ gridTemplateColumns: `repeat(${total}, minmax(0, 1fr))` }} aria-hidden="true">
        {view.segments.map((segment, index) => (
          <span
            key={index}
            className={`h-1.5 rounded-full ${
              segment === "sent" ? tone.sent : segment === "failed" ? "bg-red-600" : segment === "next" ? "" : "bg-gray-200"
            }`}
            style={
              segment === "next"
                ? { background: "repeating-linear-gradient(90deg, #4f46e5 0 4px, transparent 4px 7px)" }
                : undefined
            }
          />
        ))}
      </div>
      {view.detail && <div className="mt-1 truncate text-xs text-gray-600" title={view.detail}>{view.detail}</div>}
    </div>
  );
}
